export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
};

export const dateFormat = (str) => {
  const st = new Date(str);
  const dt = `${st.getDate()}/${st.getMonth() + 1}/${st.getFullYear()}`;
  return dt;
};
export const dateFormat2 = (str) => {
  const st = new Date(str);
  const dt = `${st.getFullYear()}-${st.getMonth() + 1}-${st.getDate()}`;
  return dt;
};
